import { Schema } from "effect";

export const PrvApplicant = Schema.Struct({
  identifier: Schema.String,
  reference: Schema.OptionFromNullOr(Schema.String),
  name: Schema.String,
  address: Schema.OptionFromNullOr(Schema.String),
  countryCode: Schema.OptionFromNullOr(Schema.String),
});

export const PrvRepresentative = Schema.Struct({
  identifier: Schema.String,
  reference: Schema.OptionFromNullOr(Schema.String),
  name: Schema.String,
  address: Schema.OptionFromNullOr(Schema.String),
  countryCode: Schema.OptionFromNullOr(Schema.String),
});

export const PrvEvent = Schema.Struct({
  eventDate: Schema.String, // ISO date string
  eventCode: Schema.String,
});

export const PrvImage = Schema.Struct({
  identifier: Schema.String,
  filename: Schema.String,
  fileFormat: Schema.String,
  categoryCodes: Schema.Array(Schema.String),
  // Optional convenience field for a proxied URL in our API
  url: Schema.optional(Schema.String),
});

export const PrvTrademarkApplication = Schema.Struct({
  applicationNumber: Schema.String,
  registrationNumber: Schema.OptionFromNullOr(Schema.String),
  applicationDate: Schema.String,
  registrationDate: Schema.OptionFromNullOr(Schema.String),
  statusCode: Schema.String,
  kindMark: Schema.OptionFromNullOr(Schema.String),
  expiryDate: Schema.OptionFromNullOr(Schema.String),
  markFeature: Schema.OptionFromNullOr(Schema.String),
  markVerbalElement: Schema.OptionFromNullOr(Schema.String),
  useLimitationText: Schema.OptionFromNullOr(Schema.String),

  applicants: Schema.Array(PrvApplicant),
  representatives: Schema.Array(PrvRepresentative),
  events: Schema.Array(PrvEvent),
  images: Schema.Array(PrvImage),
});

export const Pagination = Schema.Struct({
  limit: Schema.Number,
  offset: Schema.Number,
  count: Schema.Number,
});

export const PaginatedResponse = <A extends Schema.Top>(item: A) =>
  Schema.Struct({
    items: Schema.Array(item),
    pagination: Pagination,
  });

// Url/query param schemas
export const PrvTrademarksPaginationParams = Schema.Struct({
  limit: Schema.NumberFromString,
  offset: Schema.NumberFromString,
});

export const PrvTrademarksSearchParams = Schema.Struct({
  q: Schema.String,
  limit: Schema.NumberFromString,
  offset: Schema.NumberFromString,
});
